<template>
    <div class="panel panel-default">
        <div class="panel-body text-center" style="padding: 50px 0;">
            <h1 style="font-size: 36px;">
                {{ greeting }}, {{ name }}!
            </h1>
        </div>
    </div>
</template>

<script>
import store from '@/store'

export default {
    data() {
        return {
            shared: store
        }
    },

    computed: {
        greeting() {
            if ((new Date).getHours() < 3) {
                return 'Go to bed'
            }
            if ((new Date).getHours() >= 6 && (new Date).getHours() < 12) {
                return 'Good morning'
            }

            if ((new Date).getHours() >= 12 && (new Date).getHours() < 18) {
                return 'Good afternoon'
            }

            if ((new Date).getHours() >= 18 && (new Date).getHours() < 21) {
                return 'Good evening'
            }

            return 'Hello'
        },

        name() {
            return this.shared.user.first_name
        }
    }
}
</script>
